import { FC, useContext } from "react";
import { Payload } from "../@types/common";
import { APIContext } from "../context/context";
import { translation as t } from "../utils/translation";
import ContactUs from "./contactUs";
interface Props {
  params: Payload;
  position: string;
}
export const MortgageRequestButton: FC<Props> = ({ params, position }) => {
  const API_AND_URLS = useContext(APIContext);
  const urlMortgageRequest =
    API_AND_URLS !== undefined ? API_AND_URLS.URLS.MORTGAGE_REQUEST : "";
  return (
    <div className="flex justify-center items-center my-7">
      <a
        href={urlMortgageRequest}
        target="_blank"
        onClick={() =>
          window.dataLayer.push({
            Category: "Mortgage Calculator",
            Action: "Ask For Mortage",
            Label: `go to form ${position}`,
            event: "auto_event",
            ...params,
          })
        }
        className="bg-darkBlue text-white text-[24px] font-bold px-10 xs:px-2 xxl:px-5 text-center py-1 my-0 mx-auto rounded-m"
      >
        {t.MORTGAGE_REQUEST_BUTTON}
      </a>
    </div>
  );
};
const ResultsLinks: FC<Props> = ({ params }) => {
  return (
    <>
      <MortgageRequestButton params={params} position={'bottom'}/>
      <ContactUs params={params} />
    </>
  );
};
export default ResultsLinks;